module.exports = __webpack_public_path__ + "img/kbmb.da3c58b6.jpg";